import OperationHours from './OperationHours';

export default OperationHours;
